import { change } from 'redux-form';

import { loading, success, handleErrorException } from 'State/actions';
import { PROVISION2_FORM_NAME } from 'Common/FormEnum';
import { Provision2FieldEnum as Fields } from 'Common/FieldEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { isRequestCancelation } from 'Common/Helpers';

import * as types from './types';

export const getServedItems = (siteId, mealType) => {
  return async (dispatch, getState, MPWWebAPI) => {
    dispatch(loading(types.GET_SERVED_ITEMS_LOADING, true));
    try {
      const response = await MPWWebAPI.getGeneric(
        `Provision2/GetServedItems/${siteId}/${mealType}`
      );
      const servedItems = response.data.Data || [];

      dispatch(success(types.GET_SERVED_ITEMS_SUCCESS, servedItems));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching reimbursable items. Please try again.',
      };
      dispatch(
        handleErrorException(ex, types.GET_SERVED_ITEMS_ERROR, defaultError)
      );
    }
    dispatch(loading(types.GET_SERVED_ITEMS_LOADING, false));
  };
};

export const getCalculation = data => {
  return async (dispatch, getState, MPWWebAPI) => {
    try {
      const { Api, source } = MPWWebAPI.createCancelableApi();

      dispatch(loading(types.GET_CALCULATION_LOADING, true, true, source));

      const response = await Api.postGenericInsertUpdate(
        'Provision2/GetCalculation',
        data
      );

      const calculation = response.data.Data;

      dispatch(success(types.GET_CALCULATION_SUCCESS, calculation));

      dispatch(
        change(PROVISION2_FORM_NAME, Fields.Free, calculation[Fields.Free])
      );
      dispatch(
        change(
          PROVISION2_FORM_NAME,
          Fields.Reduced,
          calculation[Fields.Reduced]
        )
      );
      dispatch(
        change(PROVISION2_FORM_NAME, Fields.Paid, calculation[Fields.Paid])
      );
      dispatch(loading(types.GET_CALCULATION_LOADING, false));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching reimbursable items. Please try again.',
      };
      dispatch(
        handleErrorException(ex, types.GET_CALCULATION_ERROR, defaultError)
      );
      if (!isRequestCancelation(ex)) {
        dispatch(loading(types.GET_CALCULATION_LOADING, false));
      }
    }
  };
};

export const writeProvision2Meals = data => {
  return async (dispatch, getState, MPWWebAPI) => {
    try {
      dispatch(loading(types.WRITE_PROVISION2_MEALS_LOADING, true));

      await MPWWebAPI.postGenericInsertUpdate(
        'Provision2/WriteProvision2Meals',
        data
      );

      dispatch(success(types.WRITE_PROVISION2_MEALS_SUCCESS));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching reimbursable items. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.WRITE_PROVISION2_MEALS_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.WRITE_PROVISION2_MEALS_LOADING, false));
    }
  };
};

export const resetError = () => ({
  type: types.RESET_ERROR,
});

export const resetWriteSuccessful = () => ({
  type: types.RESET_WRITE_SUCCESSFUL,
});

export const resetWriteError = () => ({
  type: types.RESET_WRITE_ERROR,
});



// WEBPACK FOOTER //
// ./src/pages/provision2/state/actions.js